import React from 'react';

import { Box, Typography } from '@mui/material';

type Props = {
  /** セクション見出し */
  title: string;
  /** 見出し右に置く補助要素（任意） */
  action?: React.ReactNode;
  children: React.ReactNode;
};

/**
 * 詳細/フォームパネル内のセクション（見出し + 内容）。
 * 各フォームで重複していた「subtitle2 / fontWeight 600 / text.secondary の見出し + Grid」を共通化する。
 */
const FormSection: React.FC<Props> = ({ title, action, children }) => (
  <Box>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 1.5,
      }}
    >
      <Typography variant="subtitle2" fontWeight={600} color="text.secondary">
        {title}
      </Typography>
      {action}
    </Box>
    {children}
  </Box>
);

export default FormSection;
